// extracted by mini-css-extract-plugin
export default {"modalOverlay":"UI-z","modalContent":"VI-z","header":"WI-z","close":"XI-z"};